"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const ToastContext_1 = require("context/ToastContext");
const useFilter_1 = __importDefault(require("hooks/useFilter"));
const HelperUtils_1 = require("utils/HelperUtils");
const SurveyHelper_1 = require("utils/SurveyHelper");
const ListEmptyState_1 = __importDefault(require("components/shared/ListEmptyState"));
const EmptyStateResult = ({ isThereFilter, isPast, surveyId, occurrenceId }) => {
    const { addToast } = (0, ToastContext_1.useToastContext)();
    const showMenuFilter = (0, useFilter_1.default)((state) => state?.showMenuFilter);
    const setShowMenuFilter = (0, useFilter_1.default)((state) => state?.setShowMenuFilter);
    const reminderHandler = async () => {
        const { remindSuccess, remainingHours, remainingMinutes } = await (0, SurveyHelper_1.sendReminderHandler)(surveyId, {
            surveyOccurrenceId: occurrenceId
        });
        addToast({
            msg: (0, HelperUtils_1.getCultureLocale)(remindSuccess
                ? 'Email reminder has been sent.'
                : `You can send another reminder in the next ${remainingHours}h ${remainingMinutes}m`),
            title: (0, HelperUtils_1.getCultureLocale)(remindSuccess ? 'Remind Successful' : 'Remind Failed'),
            type: remindSuccess ? 'success' : 'error'
        });
    };
    const onClickButton = () => {
        if (isPast && isThereFilter) {
            setShowMenuFilter(!showMenuFilter);
        }
        else {
            reminderHandler();
        }
    };
    return (
    // @ts-ignore
    react_1.default.createElement(ListEmptyState_1.default, { fullHeight: true, emptyIcon: (0, HelperUtils_1.getCultureLocale)(isThereFilter ? 'icon-no-result-found' : 'icon-no-survey'), title: (0, HelperUtils_1.getCultureLocale)(isPast ? 'No Participant Response.' : 'No Response Yet'), subtitle: (0, HelperUtils_1.getCultureLocale)(isPast && isThereFilter
            ? 'There is no response in this filter. Adjust filters via button below to view survey summary.'
            : isPast
                ? 'This Past Survey has No Response'
                : "There have been no responses to this survey yet. You can \nsend a reminder to everyone who participated in the survey\nby clicking the 'Remind' button below"), btnText: (0, HelperUtils_1.getCultureLocale)(!isPast ? 'Remind' : isPast && isThereFilter ? 'Adjust Filter' : ''), onClick: onClickButton }));
};
exports.default = EmptyStateResult;
